import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../Enter/Enter";
import Display from "../Display/Display";
import "./main.css";
import { ToastContainer } from "react-toastify";
const MainUser = () => {
  const [key, setKey] = useState("display");
  const [Passwordp, setPasswordp] = useState("password");
  const [Passwordc, setPasswordc] = useState("password");
  const [Itemid, setItemid] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordconfirmInput, setpasswordconfirmInput] = useState("");
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [showDelete, setshowDelete] = useState(false);
  const [foc, setfoc] = useState(false);
  const [isPress, setIsPress] = useState(false);
  const [loading, setLoading] = useState(true);
  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة بيانات المستخدمين</h4>

        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              <Tab eventKey="enter" title="إدخال">
                <Enter
                  Passwordp={Passwordp}
                  setPasswordp={setPasswordp}
                  Passwordc={Passwordc}
                  setPasswordc={setPasswordc}
                  passwordInput={passwordInput}
                  Itemid={Itemid}
                  setPasswordInput={setPasswordInput}
                  passwordconfirmInput={passwordconfirmInput}
                  setpasswordconfirmInput={setpasswordconfirmInput}
                  Phone={Phone}
                  setPhone={setPhone}
                  Email={Email}
                  setEmail={setEmail}
                  Name={Name}
                  setName={setName}
                  foc={foc}
                  setfoc={setfoc}
                  setLoading={setLoading}
                  setIsPress={setIsPress}
                  loading={loading}
                  isPress={isPress}
                />
              </Tab>
              <Tab eventKey="display" title="عرض">
                <Display
                  setKey={setKey}
                  setItemid={setItemid}
                  Itemid={Itemid}
                  setPhone={setPhone}
                  showDelete={showDelete}
                  setshowDelete={setshowDelete}
                  setEmail={setEmail}
                  setName={setName}
                  setfoc={setfoc}
                  setLoading={setLoading}
                  setIsPress={setIsPress}
                  loading={loading}
                  isPress={isPress}
                />
              </Tab>
            </Tabs>
          </div>
        </Row>
        <ToastContainer autoClose={1200} />
      </Container>
    </div>
  );
};

export default MainUser;
